import { useGlobalConfigContext } from '../../../global-config'
import { TENANTS_TO_SHOW_RX_NOT_IN_CATALOG_PRODUCTS } from '../../../tenant'

import { algoliaQueryAccessorGetObjectIdFiltersQuery } from './headerSearchGetObjectIdFiltersQuery'
import { headerSearchGetPznsAndUpidsFromSearchQuery } from './headerSearchGetPznsAndUpidsFromSearchQuery'

/**
 * returns default query if no other cases met.
 * Modifies the request to algolia in case of the single PZNs search query,
 * (f.e.: `08106418 00937283 13816944 11481824`) so that it sends PZNs in filters as objectID,
 * (f.e.: `filters: objectID:08106418 OR objectID:00937283 OR objectID:13816944 OR objectID:11481824
 * AND (stockStatusReason:product.stockStatus.available OR stockStatusReason:product.stockStatus.nl)`)
 *
 * The `query` parameter should remain empty in this case.
 *
 * @param {string} searchQuery
 * @returns {string}
 */
export const useHeaderSearchAlgoliaFilters = (searchQuery: string): string => {
  const { tenant } = useGlobalConfigContext()
  const pzns = headerSearchGetPznsAndUpidsFromSearchQuery(searchQuery)

  // prescription medicines should be searchable for all stockStatusReasons other than not_in_sale or freebie(which shouldn't be the case anyway)
  const prescriptionMedicineFilter =
    'prescriptionMedicine:true AND NOT stockStatusReason:product.stockStatus.gratis AND NOT stockStatusReason:product.stockStatus.av'

  let defaultFilter = `(stockStatusReason:product.stockStatus.available OR stockStatusReason:product.stockStatus.nl)`

  const allValid = Array.isArray(pzns) && pzns.length > 0

  if (TENANTS_TO_SHOW_RX_NOT_IN_CATALOG_PRODUCTS.includes(tenant)) {
    defaultFilter = `${defaultFilter} OR ${prescriptionMedicineFilter}`
  }

  if (!allValid) {
    return defaultFilter
  }

  const objectIdFiltersQuery = algoliaQueryAccessorGetObjectIdFiltersQuery(pzns)

  return objectIdFiltersQuery
}
